module.exports = __webpack_public_path__ + "img/Terraform-Inspect-Medium.a21d4de4.png";